import React from 'react'

import styled from '@emotion/styled'
import {
  Box,
  Body2,
  Bold,
  Display,
  FlexDirection,
  AlignItems,
  Color,
  Display3,
  Heading4,
  TextAlign,
  JustifyContent,
  Image,
} from '@gousto-internal/citrus-react'

import GoustoLoveBox from './assets/GousoLoveBox.svg'

const YouGetContainer = styled(Box)`
  gap: 10px;
`

interface RafYouGetProps {
  credit: string
}

export const RafYouGet: React.FC<RafYouGetProps> = ({ credit }) => (
  <YouGetContainer
    display={Display.Flex}
    flexDirection={FlexDirection.Column}
    alignItems={AlignItems.Center}
    gap={[4, 4, 2, 2]}
  >
    <Body2
      color={Color.ColdGrey_800}
      size={5}
      display={[Display.Block, Display.Block, Display.None, Display.None]}
    >
      <Bold>You get</Bold>
    </Body2>
    <Box display={Display.Flex} flexDirection={FlexDirection.Row} alignItems={AlignItems.Center}>
      <Box display="block">
        <Image
          width={['117px', '117px', 'auto', 'auto']}
          height={['72px', '72px', 'auto', 'auto']}
          src={GoustoLoveBox}
          alt="Gouso Love Box"
          fit="contain"
        />
      </Box>
      {/* you get */}
      <Box
        display="flex"
        flexDirection={FlexDirection.Column}
        alignItems={AlignItems.Center}
        gap={[0, 0, 4, 4]}
      >
        <Body2 color={Color.ColdGrey_800} size={4}>
          <Bold display={[Display.None, Display.None, Display.Block, Display.Block]}>You get</Bold>
        </Body2>
        {/* credit blob */}
        <Box
          display="flex"
          flexDirection={FlexDirection.Column}
          bg={Color.Primary_600}
          alignItems={AlignItems.Center}
          justifyContent={JustifyContent.Center}
          borderRadius="round"
          paddingV={4}
          paddingH={4}
          height={['96px', '96px', '120px', '120px']}
          width={['96px', '96px', '120px', '120px']}
        >
          <Display3 size={[9, 9, 13, 13]} color={Color.White}>
            {credit}
          </Display3>
          <Heading4 color={Color.White}>credit</Heading4>
        </Box>
        <Body2
          color={Color.ColdGrey_800}
          textAlign={TextAlign.Center}
          display={[Display.None, Display.None, Display.Block, Display.Block]}
        >
          <Bold>
            towards your
            <br />
            next box
          </Bold>
        </Body2>
      </Box>
    </Box>
  </YouGetContainer>
)
